export default {
  computed: {
    isVatan() {
      return window.location.href.includes('vatan');
    },
  },
};
